import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: '/',
        component: () => import('../views/action.vue')
    },
    // {
    //     path: '/action',
    //     name: '/action',
    //     component: () =>
    //         import('../views/action.vue')
    // },
    {
        path: '/mainIndex',
        name: '/mainIndex',
        component: () =>
            import('../views/mainIndex.vue')
    },
    {
        path: '/mainIndex2',
        name: '/mainIndex2',
        component: () =>
            import('../views/mainIndex2.vue')
    },
    {
        path: '/mainIndex3',
        name: '/mainIndex3',
        component: () =>
            import('../views/mainIndex3.vue')
    },
    {
        path: '/mainIndex4list',
        name: '/mainIndex4list',
        component: () =>
            import('../views/mainIndex4list.vue')
    }, {
        path: '/mainIndex5',
        name: '/mainIndex5',
        component: () =>
            import('../views/mainIndex5.vue')
    },
    {
        path: '/certificate',
        name: '/certificate',
        component: () =>
            import('../views/certificate.vue')
    },

]
const orginalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return (orginalPush.call(this, location)).catch(err => err)
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router